import React, { Component } from "react";
import AvatarEditor from "react-avatar-editor";
import Button from "react-bootstrap-button-loader";
import Dropzone from "react-dropzone";
import { Line } from "rc-progress";
import { classNames } from "Constants";
import LocaleStrings from "Languages";
var Loader = require("react-loaders").Loader;
export default class AdvertInlineCropper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canvasRecource: props.canvasRecource,
      imagePreviewUrl: props.imagePreviewUrl,
      imagepath: props.imagepath,
      imageErrorClsName: "alert-danger",
      imageErrorMsg: "",
      minScale: 1,
      maxScale: 2,
      scaleStep: 0.05,
      scale: 1, // 1.02
      defaultScale: 1, // 1.02
      fileLoading: false,
    };

    this.setEditorRef = this.setEditorRef.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.resetImage = this.resetImage.bind(this);
    this.onDropFile = this.onDropFile.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // if (nextProps) {
    //   if (nextProps.imagepath !== "" && this.state.imagepath === "") {
    //     this.setState({ imagepath: nextProps.imagepath });
    //   }
    // }
  }

  setEditorRef = (editor) => (this.editor = editor);

  onClickSave = () => {
    this.saveImage(null);
  };

  saveImage = (callback) => {
    if (this.editor) {
      var imageType = this.props.imageType;
      if (!imageType) imageType = "jpg";

      var img;
      if (imageType === "png") img = this.editor.getImage().toDataURL();
      else img = this.editor.getImage().toDataURL("image/jpeg", 0.9);
      this.setState({ imagepath: img });
      this.props.onImageSave(img);
      if (callback) {
        setTimeout(() => {
          callback();
        }, 2000);
      }
    }
  };

  resetImage = () => {
    this.setState({
      canvasRecource: "",
      imagepath: "",
      scale: this.state.defaultScale,
      imageErrorMsg: "",
    });
    this.props.onImageSave("");
    this.props.onImageChange(false);
  };

  onDropFile = (files) => {
    let file = files[0];
    let requiredHeight = this.props.height;
    let requiredWidth = this.props.width;
    let that = this;
    that.setState({ fileLoading: true });

    let reader = new FileReader();
    if (file && file.type.indexOf("image") != -1) {
      reader.onload = (e) => {
        let img = new Image();
        img.src = reader.result;

        img.onload = function () {
          let width = this.width;
          let height = this.height;

          if (width < requiredWidth || height < requiredHeight) {
            that.setState({
              imageErrorMsg:
                "Image is smaller than recommended image, upload another image.!",
            });
            that.props.onImageChange(false);
          } else {
            that.setState({
              ...this.state,
              canvasRecource: reader.result,
              imageErrorMsg: "",
            });
            that.props.onImageChange(true);
          }
        };
        // this.props.onImageChange(true);
      };
      reader.readAsDataURL(file);
    }
    reader.onloadend = () => {
      that.setState({ fileLoading: false });
    };
  };

  onZoomOut() {
    var scale = this.state.scale;
    scale = scale - this.state.scaleStep;
    if (scale < this.state.minScale) scale = this.state.minScale;
    this.setState({ ...this.state, scale });
  }

  onZoomIn() {
    var scale = this.state.scale;
    scale = scale + this.state.scaleStep;
    if (scale > this.state.maxScale) scale = this.state.maxScale;
    this.setState({ ...this.state, scale });
  }

  render() {
    let { callfrom } = this.props;

    let imageUrl = this.state.imagepath;
    var hideDropZoneClass = "";
    var hideCropZineClass = "hide-feature";
    var hideControlButton = "hide-feature";

    if (imageUrl && imageUrl !== "file object not found") {
      hideDropZoneClass = "hide-feature";
      hideCropZineClass = "hide-feature";
      hideControlButton = "";
    }

    if (this.state.canvasRecource && !imageUrl) {
      hideDropZoneClass = "hide-feature";
      hideCropZineClass = "";
    }
    if (this.state.imageErrorMsg != "") {
      hideControlButton = "";
      hideDropZoneClass = "hide-feature";
    }

    var imageErrorStyle = {
      padding: "5px",
      margin: "5px 0px",
    };

    var imageStyle = {
      width: this.props.width / 3,
      height: this.props.height / 3,
    };

    let specialStyleDropZone = {};
    let specialStyleCrossButton = {};
    if (callfrom && callfrom === "Exhibitor") {
      specialStyleDropZone["position"] = "ralative";
      specialStyleCrossButton["position"] = "absolute";
      specialStyleCrossButton["top"] = "239px";
      specialStyleCrossButton["left"] = "19%";
    }

    return (
      <div>
        <Dropzone onDrop={this.onDropFile} accept="image/*" multiple={false}>
          {({ getRootProps, getInputProps }) => (
            <div
              style={specialStyleDropZone}
              {...getRootProps()}
              className={`drop-zone-area ${hideDropZoneClass}`}
            >
              <input {...getInputProps()} />
              {this.state.fileLoading ? (
                <div className="file-drop-loader d-flex flex-column mt-20 justify-content-center align-items-center">
                  <Loader
                    type="line-scale-pulse-out-rapid"
                    active
                    className="loader-div"
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </Dropzone>
        {this.state.imageErrorMsg && this.state.imageErrorMsg != "" ? (
          <div className={this.state.imageErrorClsName} style={imageErrorStyle}>
            {this.state.imageErrorMsg}
          </div>
        ) : (
          <div>
            <img
              style={imageStyle}
              src={imageUrl}
              alt=""
              className={`img-responsive logoImgSize ${hideControlButton}`}
            />

            <div className={hideCropZineClass}>
              <AvatarEditor
                image={this.state.canvasRecource}
                color={[0, 0, 0, 0.5]} // RGBA
                scale={this.state.scale}
                rotate={0}
                ref={this.setEditorRef}
                disabledrop="true"
                width={this.props.width / 3}
                height={this.props.height / 3}
                className="editor-canvas"
                style={{ background: "#777" }}
              />
              <div className="dropzone-control-button">
                <Button
                  type="button"
                  className="btn i-custom-blue mb-5"
                  onClick={this.onZoomIn.bind(this)}
                >
                  {" "}
                  <i className="fa fa-search-plus"></i>{" "}
                </Button>
                <Button
                  type="button"
                  className="btn i-custom-blue mb-5"
                  onClick={this.onZoomOut.bind(this)}
                >
                  {" "}
                  <i className="fa fa-search-minus"></i>
                </Button>
                <Button
                  type="button"
                  className="btn btn-custom-blue mb-5"
                  onClick={this.onClickSave}
                >
                  {LocaleStrings.button_crop_save}
                </Button>
                {/* Special case  Note :- For exhibitor size is less that is why we will show cross image button above and hide from here */}

                {callfrom && callfrom === "Exhibitor" ? (
                  <i
                    className={"fa fa-times exhibitor-cross-icon"}
                    style={specialStyleCrossButton}
                    onClick={this.resetImage}
                  ></i>
                ) : (
                  <Button
                    type="button"
                    className="btn i-custom-red mb-5"
                    onClick={this.resetImage}
                  >
                    <img
                      className="i-custom-normal"
                      src="../../style/images/custom-icons/shape-1317-copy-3.svg"
                    />
                  </Button>
                )}
              </div>
            </div>
          </div>
        )}

        <div className={hideControlButton}>
          <Button
            type="button"
            className="btn btn-custom-blue"
            onClick={this.resetImage}
          >
            {" "}
            Upload new image{" "}
          </Button>
        </div>
      </div>
    );
  }
}
